(ns common.validators.core
  (:require ["moment-timezone" :as moment]
            [clojure.string :as str]
            [common.ui.validation.db :refer [validate]]
            [phrase.alpha :as p]))

(defn url? [value]
  (boolean (re-matches #"^https?://.+" value)))

(defn s3-url? [value]
  (boolean (re-matches #"^s3://.+" value)))

;; Matches lemonpi.io URLs (with optional subdomain), but excludes URLs that contain "http(s)" in the path.
;; Used to avoid matching cached or proxied URLs that point back to full https:// links on our own domain.
(defn internal-url? [value]
  (boolean (re-matches #"^https?://(?:.+\.)?lemonpi.io(?!/.*https?://)(?:/.*)?$" value)))

(defn valid-placeholder-name? [value]
  (empty? (validate :placeholder/name value)))

(defn valid-timezone? [tz]
  (boolean (.. moment -tz (zone tz))))

(defn valid-date?
  "Checks if value is a date of form yyyy-mm-dd"
  [value]
  (boolean (re-matches #"^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$" value)))

(defn valid-characters-for-name? [name]
  (boolean (re-matches #"^[\w \t\f\v,:;!?/\|\\\.\(\)\[\]\&\+=\'`´‘’„“”″\"{}@€\&*#%®™°\-–—─]+$" name)))

(defn valid-email?
  [email]
  (re-matches #".+\@.+\..+" email))

(p/defphraser url?
  [_ problem]
  {:in (:in problem)
   :message "The field should be a valid URL"
   :problem problem})

(p/defphraser s3-url?
  [_ problem]
  {:message "The field should be a valid http(s) or s3 url"
   :in (:in problem)
   :problem problem})

(p/defphraser valid-placeholder-name?
  [_ problem]
  {:message "The field should only contain letters, digits, '-' and '_'"
   :in (:in problem)
   :problem problem})

(p/defphraser valid-timezone?
  [_ problem]
  {:message "The field should be a valid timezone"
   :in (:in problem)
   :problem problem})

(p/defphraser valid-date?
  [_ problem]
  {:message "The field should be a valid date"
   :in (:in problem)
   :problem problem})

(p/defphraser #(<= (count %) max-size)
  [_ problem max-size]
  {:message (str "The field can not be longer than " max-size " characters")
   :in (:in problem)
   :problem problem})

(p/defphraser (complement str/blank?)
  [_ problem]
  {:message "The field should not be empty"
   :in (:in problem)
   :problem problem})

(p/defphraser string?
  [_ problem key]
  {:message "The field should be a string"
   :in (:in problem)
   :problem problem})

(p/defphraser valid-characters-for-name?
  [_ problem]
  {:message "Field may not contain any forbidden special characters (eg. '<', '>')"
   :in (:in problem)
   :problem problem})

